<div class="reset-password-page-container">
  <div class="reset-password-content-wrapper">
    <div class="reset-password-wrapper-title">
      <span class="reset-password-title">{{
        "resetPassword.title" | translate
      }}</span>
    </div>
    <div class="reset-password-form-wrapper">
      <div class="reset-password-fixed-form-container">
        @let showResetPasswordInfoToast = showResetPasswordInfoToastSignal();
        <div class="reset-password-toast-container">
          @if (showResetPasswordInfoToast) {
            <app-callout [calloutData]="resetPasswordInfoToastConfig" />
          } @else {
            <app-callout [calloutData]="resetPasswordErrorToastConfig" />
          }
        </div>

        <ng-gencat-form
          (loaded)="resetPasswordFormLoaded($event)"
          [controls]="resetPasswordFormConfig"
        />

        <div class="reset-password-button-wrapper">
          <button-component
            text="forgotPassword.button"
            customId="request_password_reset_button"
            [tmobBtnStyle]="primaryButton"
            [appButtonDisable]="!readyResetPasswordSignal()"
            (click)="resetPassword()"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="reset-password-wrapper-image">
    <div class="image-reset-password-background"></div>
  </div>
</div>
